export default __webpack_public_path__ + "static/media/wheelchair.85387c51.gif";